let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iHaR1")).then(() => parcelRequire('88S3w'));